import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { BehaviorSubject } from 'rxjs';
import { LoginService } from './login.service';
declare var window: any;

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public user: BehaviorSubject<any> = new BehaviorSubject<any>('');;
  constructor(
    @Inject(LOCAL_STORAGE) public sessionStorage: any, public loginService: LoginService
  ) {
    //this.init();
  }

  login() {
    window.google.accounts.oauth2.initTokenClient({
      client_id: '137478054331-ig5rvfk5llgso34nf0sronfh0am1ml5b.apps.googleusercontent.com',
      scope: 'profile email ',
      callback: (response: any) => this.handle(response)
    }).requestAccessToken();
  }

  logout() {
    console.log('User logged out');
  }

  init(): void {
    window.onload = () => {
      if(!window.google.accounts) return;

      window.google.accounts.id.initialize({
        client_id: '137478054331-ig5rvfk5llgso34nf0sronfh0am1ml5b.apps.googleusercontent.com',
        callback: (token:any) => {
          this.handle(token);
        }
      });
    };
    setTimeout(() => {
      let token = this.sessionStorage.getItem('usertoken');
      if (!token) {
        window.google.accounts.id.prompt();
      }
    }, 3000)

    // this.fireAuth.onAuthStateChanged((user) => {
    //   this.user.next(user);
    //   if (!user) {
    //     window.google.accounts.id.prompt();
    //   }
    // });
  }

  handle(token:any): void {
    // console.log(token)
    // var base64Url = token.access_token.split('.')[1];
    this.loginService.verifyToken(token.access_token).subscribe(res=>{
      if(res){
         this.user.next(res)
    this.sessionStorage.setItem('googleData', JSON.stringify(res))
      }
    })
    // console.log(base64Url)

    // var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    // var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    //   return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    // }).join(''));

    // this.user.next(JSON.parse(jsonPayload))
    // this.sessionStorage.setItem('googleData', jsonPayload)
    // console.log(jsonPayload)
  }


  signOut(): void {
    // this.fireAuth.signOut();
  }
}